/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterL = createReactComponent("letter-l", "IconLetterL", [
  ["path", { d: "M7 4v16h10", key: "svg-0" }]
]);

export { IconLetterL as default };
//# sourceMappingURL=IconLetterL.js.map
